import { Injectable } from "@angular/core";

import { BehaviorSubject } from "rxjs";

@Injectable()
export class PageTitleService {
    pageTitle: BehaviorSubject<any> = new BehaviorSubject(null);
    pageName: BehaviorSubject<any> = new BehaviorSubject(null);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/page-title.service.ts